import React from 'react';
import SeasonFilter from '../SeasonFilter';

const FiltersPanel = ({
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  matchType,
  onMatchTypeChange,
  matchTypes,
  region,
  onRegionChange,
  availableRegions,
  selectedSeason,
  onSeasonChange
}) => {
  return (
    <div className="filter-panel dashboard-filter-shell">
      <div className="aligned-left-block dashboard-filter-inner">
        <h3 className="dashboard-filter-title">Filter Stats</h3>
        <div className="filter-grid dashboard-filter-grid">
          {/* Unified Season + Date Filter */}
          <SeasonFilter
            selectedSeason={selectedSeason}
            onSeasonChange={onSeasonChange}
            startDate={startDate}
            onStartDateChange={onStartDateChange}
            endDate={endDate}
            onEndDateChange={onEndDateChange}
          />

          <div className="dashboard-filter-field">
            <label>Match Type</label>
            <select value={matchType} onChange={onMatchTypeChange} className="dashboard-select">
              <option value="">All</option>
              {matchTypes.map((type, idx) => (
                <option key={idx} value={type}>{type}</option>
              ))}
            </select>
          </div>
          
          <div className="dashboard-filter-field">
            <label>Region</label>
            <select value={region} onChange={onRegionChange} className="dashboard-select">
              <option value="">All</option>
              {availableRegions.map((r, i) => (
                <option key={i} value={r}>{r}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersPanel;

